function clearSession() {
  localStorage.clear();
  sessionStorage.clear();
}

export default clearSession;
